import { useState } from 'react';
import { useValidated } from './useValidated';
export function useValidatedState(initialValue, onChangeCallback, onValidateCallback) {
    const [value, setValue] = useState(initialValue);
    const [errors, onValidate, isValid] = useValidated(onValidateCallback);
    const onChangeHandler = (newValue) => {
        setValue(newValue);
        if (onChangeCallback)
            onChangeCallback(newValue);
    };
    return [value, onChangeHandler, isValid, errors, onValidate, setValue];
}
